import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import $ from 'jquery';

import { selectUrlData } from '../../redux/train/train.selector';

import iconBack from '../../assets/back-arrow.png';
import iconClose from '../../assets/close.png';

class FaqDetailsPayment extends React.Component {
    constructor(props) {
        super(props);
        window.jQuery = $;
        window.$ = $;
        global.jQuery = $;
    }
    myFunction(e) {
        $('.single-faq').removeClass('active');
        $(e).parent('.single-faq').addClass('active');
    }
    render() {
        const { urlData } = this.props;
        return (
            <div>
                <div className="faq-header">
                    <a href={'/ttbhelp?' + urlData}><img src={iconBack} alt="" title="" /></a>
                    <h2>Frequently Asked Questions(FAQ):</h2>
                    <Link to={'/ttbhelp/faq'}><img src={iconClose} alt="" title="" /></Link>
                </div>
                <div className="faq-content">
                    <h4>Payment and Charges</h4>

                    <h2>What do you need help with?</h2>

                    <div className="faq-accordian">
                        <div className="single-faq active">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How is the fare for a train ticket calculated?</h3>
                            <p>The fare for a train ticket is calculated based on several factors:</p>

                            <li><span>Travel Class:</span> Higher classes like AC (1A, 2A, 3A) are more expensive compared to Sleeper or General class.</li>
                            <li><span>Train Type:</span> Premium trains like Rajdhani, Shatabdi, and Duronto have higher fares compared to regular express or passenger trains.</li>
                            <li><span>Distance:</span> The longer the distance between your boarding and destination stations, the higher the fare.</li>
                            <li><span>Concessions:</span> Discounts for senior citizens, children, or specific categories (students, disabled passengers) can reduce the fare.</li>
                            <li><span>Reservation Charges:</span> Extra fees for seat or berth reservations.</li>
                            <li><span>Dynamic Pricing:</span> For some trains (like Tatkal and premium trains), fares may increase based on demand.</li>
                            <li><span>Other Charges:</span> GST, superfast surcharge, catering charges (for some trains), and service fees may also be included.</li>

                            <p>These components together determine the final ticket fare.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What are the charges for Tatkal bookings?</h3>
                            <p>Tatkal charges are added to the base fare when booking last-minute tickets under the Tatkal quota. The charges are as follows:</p>


                            <li><span>For Sleeper Class (SL):</span> ₹100 to ₹200 per ticket.</li>
                            <li><span>For AC Classes:</span>
                                <ul>
                                    <li>3AC: ₹300 to ₹400 per ticket.</li>
                                    <li>2AC: ₹400 to ₹500 per ticket.</li>
                                    <li>1AC: No Tatkal quota available.</li>
                                </ul>
                            </li>
                            <li><span>For Non-AC Chair Car (CC):</span> ₹125 to ₹225 per ticket.</li>
                            <li><span>For AC Chair Car (CC):</span> ₹150 to ₹250 per ticket.</li>


                            <p>Note: These charges are in addition to the base fare and vary depending on the distance traveled. Dynamic pricing may apply, increasing the cost as demand rises. Tatkal bookings also attract additional reservation and service charges.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>Why was I charged more than the ticket price?</h3>
                            <p>You may be charged more than the base ticket price due to the following reasons:</p>

                            <li><span >Tatkal Charges:</span> If you booked under the Tatkal quota, additional fees are applied based on the class of travel.</li>
                            <li><span>Service Fees:</span> Booking platforms like RailYatri or IRCTC may charge a nominal service fee.</li>
                            <li><span>Catering Charges:</span> Some trains include charges for onboard catering services.</li>
                            <li><span>Dynamic Pricing:</span> On some premium trains or last-minute bookings, fares increase based on demand.</li>

                            <p>These components are added to the base fare, leading to a higher final charge.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>What should I do if my payment fails during booking?</h3>
                            <p>If your payment fails during booking, follow these steps:</p>

                            <li><span>Check Transaction Status:</span> Visit the "My Bookings" or "Transaction History" section in the RailYatri app.</li>
                            <li><span>Wait for Refund:</span> If the amount was deducted but the booking wasn’t successful, the refund will typically be processed within 1 hour. You can either wait for this time period or contact RailYatri support.</li>
                            <li><span>Retry the Payment:</span> If confirmed that the payment did not go through or has been refunded, you can safely retry the payment. Contacting support will also help avoid duplicate bookings if you're unsure about the transaction.</li>
                            <li><span>Contact Support:</span> If there's any confusion or delay beyond 1 hour, reach out to RailYatri customer support with your transaction details for assistance.</li>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How do I get a refund for a failed payment?</h3>
                            <p>Refunds for failed payments are typically processed automatically. Here’s what you can do:</p>

                            <li><span>Check Your Transaction Status:</span> Go to the "My Bookings" or "Transaction History" section of the RailYatri app to verify if the payment failed.</li>
                            <li><span>Automatic Refund:</span> If the payment was deducted but the booking wasn't successful, the refund will usually be processed within 1 hour.</li>
                            <li><span>Wait for 1 Hour:</span> If the refund doesn’t appear immediately, wait for up to 1 hour. Most payments are refunded in this period.</li>
                            <li><span>Contact Support:</span> If the refund hasn’t been processed after 1 hour, or if you’re unsure whether the payment was deducted, reach out to RailYatri customer support with the transaction ID and booking details for assistance.</li>

                            <p>RailYatri will help ensure your refund is processed or confirm the status of your payment.</p>
                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How can I apply a coupon or discount code during booking?</h3>
                            <p>After reaching the Review & Pay section of the RailYatri app:</p>

                            <li><span>Offers Section:</span> In the Offers section, you’ll see an option to enter a coupon code if you have one.</li>
                            <li><span>Apply Coupon:</span> Once you’ve applied the coupon, the discount will be reflected in the payment breakup and the invoice.</li>
                            <li><span>Proceed with Payment:</span> Proceed with the payment once the coupon is successfully applied and the updated fare is displayed.</li>

                        </div>
                        <div className="single-faq">
                            <h3 onClick={(e) => this.myFunction(e.currentTarget)}>How long does it take to process a refund after filing a TDR?</h3>
                            <p>After filing a TDR (Ticket Deposit Receipt), the refund process usually takes 7-10 business days, but can vary based on:</p>


                            <li><span>Reason for TDR Filing:</span> Cases like train cancellations or railway faults may need more verification.</li>
                            <li><span>Approval by Indian Railways:</span> Refunds are subject to their review and approval.</li>
                            <li><span>Bank Processing Time:</span> Once approved, the time to reflect in your account depends on your bank or payment provider.</li>


                            <p>Steps to Take If Refund Is Delayed:</p>


                            <li>Track TDR status via the RailYatri app or IRCTC.</li>
                            <li>Contact support for assistance.</li>
                            <li>Follow up with your bank if needed.</li>


                            <p>While 7-10 business days is typical, staying proactive by tracking your TDR status can help ensure a smooth refund process.</p>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

const mapStateProps = createStructuredSelector({
    urlData: selectUrlData
})

export default connect(mapStateProps, null)(FaqDetailsPayment);
